// extracted by mini-css-extract-plugin
module.exports = {"LogoLoadingWrapper":"DrChrono_LogoLoadingWrapper__2uR3c","HeaderTitle":"DrChrono_HeaderTitle__1RjMY"};